module.exports = __webpack_public_path__ + "static/media/horrormax-banner-the-night-of-living-dead-in-color.3b6f6671.jpg";